function getRequestHeader(request, key) {
  return request.headers[key];
}
export {
  getRequestHeader
};
